export default __webpack_public_path__ + "media/zurb/img/development-process/sass_files-bc1b3f1c1fa2280fb60a2de6d6c91b68.png";